import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { installFetchInterceptor } from "@/utils/authToken";

// Patch fetch + XHR before the app renders so every /api/* call carries
// the Bearer token from localStorage when present (Safari iOS cookie fallback).
installFetchInterceptor();

// Unregister any stale service workers from previous deployments.
// They can intercept fetch and trigger DOMException "The object can not be cloned."
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => { regs.forEach((r) => r.unregister()); })
    .catch(() => {});
  // Best-effort cache wipe
  if (typeof caches !== "undefined" && caches.keys) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

const rootEl = document.getElementById("root");

// Pre-rendered static snapshots (generated by scripts/prerender.cjs) give
// AI crawlers the full page content and give users an instant first paint.
// We intentionally use createRoot (not hydrateRoot): hydration mismatches on
// a client-only React 19 SPA with Helmet / localStorage-aware components
// are hard to avoid completely, and a partial subtree re-hydration is
// a worse UX than a <100 ms re-render on top of the already-visible content.
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
